var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttacchment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3115_10854",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3115_10854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 17.5C5.96667 17.5 4.66667 16.9667 3.6 15.9C2.53333 14.8333 2 13.5333 2 12C2 10.4667 2.53333 9.16667 3.6 8.1C4.66667 7.03333 5.96667 6.5 7.5 6.5H18C19.1 6.5 20.0417 6.89167 20.825 7.675C21.6083 8.45833 22 9.4 22 10.5C22 11.6 21.6083 12.5417 20.825 13.325C20.0417 14.1083 19.1 14.5 18 14.5H8.5C7.8 14.5 7.20833 14.2583 6.725 13.775C6.24167 13.2917 6 12.7 6 12C6 11.3 6.24167 10.7083 6.725 10.225C7.20833 9.74167 7.8 9.5 8.5 9.5H17.25C17.4667 9.5 17.646 9.57067 17.788 9.712C17.9293 9.854 18 10.0333 18 10.25C18 10.4667 17.9293 10.6457 17.788 10.787C17.646 10.929 17.4667 11 17.25 11H8.5C8.21667 11 7.97933 11.0957 7.788 11.287C7.596 11.479 7.5 11.7167 7.5 12C7.5 12.2833 7.596 12.5207 7.788 12.712C7.97933 12.904 8.21667 13 8.5 13H18C18.7 13 19.2917 12.7583 19.775 12.275C20.2583 11.7917 20.5 11.2 20.5 10.5C20.5 9.8 20.2583 9.20833 19.775 8.725C19.2917 8.24167 18.7 8 18 8H7.5C6.4 8 5.45833 8.39167 4.675 9.175C3.89167 9.95833 3.5 10.9 3.5 12C3.5 13.1 3.89167 14.0417 4.675 14.825C5.45833 15.6083 6.4 16 7.5 16H17.25C17.4667 16 17.646 16.0707 17.788 16.212C17.9293 16.354 18 16.5333 18 16.75C18 16.9667 17.9293 17.146 17.788 17.288C17.646 17.4293 17.4667 17.5 17.25 17.5H7.5Z",
    fill: "black",
    fillOpacity: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttacchment);
export default __webpack_public_path__ + "static/media/attacchment.a30f3ac6.svg";
export { ForwardRef as ReactComponent };